import apiSlice from "../api/apiSlice";

export const quizApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getQuizzes : builder.query({
            query: () => "/quizzes"
        }),
        getQuizzesByVideoId: builder.query({
            query: (id) => `/quizzes?video_id=${id}`
        }),
        getQuizById: builder.query({
            query: (id) => `/quizzes/${id}`
        }),
        addQuiz: builder.mutation({
            query: (data) => ({
                url: "/quizzes",
                method: "POST",
                body: data
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}){
                try{
                  const {data:newQuiz} = await queryFulfilled;
          
                  dispatch(apiSlice.util.updateQueryData("getQuizzes", undefined, (draft)=>{
                    
                     return draft = [...draft, newQuiz]
                  }))
                }catch{
          
                }
               }
        }),
        editQuiz: builder.mutation({
            query: ({data, id}) => ({
                url: `/quizzes/${id}`,
                method: "PATCH",
                body: data
            })
        }),
        deleteQuiz: builder.mutation({
            query: (id) => ({
                url: `/quizzes/${id}`,
                method: "DELETE"
            }),
            async onQueryStarted (arg, {dispatch, queryFulfilled}){
                // update cache
               const patchResult = dispatch(apiSlice.util.updateQueryData("getQuizzes", undefined, (draft) => {
             
                 return draft.filter((quiz) => quiz.id != arg)
                }))
                try{
                  await queryFulfilled;
                }catch{
                  patchResult.undo();
                }
               }
        }),
        getQuizMarks: builder.query({
            query: () => '/quizMark'
        }),
        getQuizMarksById: builder.query({
            query: (videoId) => `/quizMark?video_id=${videoId}`
        }),
        submitQuiz: builder.mutation({
            query: (data) => ({
                url: '/quizMark',
                method: 'POST',
                body: data
            }),
        }),
    })
})

export const { useGetQuizzesQuery, useSubmitQuizMutation, useGetQuizMarksByIdQuery, useGetQuizMarksQuery, useGetQuizzesByVideoIdQuery, useAddQuizMutation, useEditQuizMutation, useGetQuizByIdQuery, useDeleteQuizMutation } = quizApi;